
//old
const menu = [

  
  {
    icon: "dashboard",
    text: "Dashboard",
    link: "/",
    dashboard: true,
  },
  {
    icon:"package-fill",
    text:"Main Packages",
    link:"/products",
    dashboard: true,   
  },
  {
    icon:"note-add",
    text:"Addon Packages",
    link:"/add-on",
    dashboard:false,
  },
  {
    icon:"cart",
    text:"Orders / Services",
    link:"/orders",
    dashboard:false,
  },
  {
    icon:"trash",
    text:"Trash Orders",
    link:"/trash-orders",
    dashboard:false,
  },
  {
    icon:"offer",
    text:"Coupons",
    link:"/coupons",
    dashboard:false,
  },
  {
    icon:"inbox",
    text:"Category",
    link:"/categories",
    dashboard:false,
  },
  {
    icon:"help-alt",
    text:"Emirates",
    link:"/emirates",
    dashboard:false,
  },
  {
    icon:"building",
    text:"Zones",
    link:"/freezone",
    dashboard:false,
  },
  { icon:"help", text:"Zone FAQs", link:"/zone-faqs", dashboard:false },
  {
    icon: "layers-fill",
    text: "Freezone Activities",
    active: false,
    subMenu: [      
      {
        text:"License",
        link:"/license",
      },
      {
        text:"Sub License",
        link:"/sub-license",
      },
      {
        text:"Sub License Group",
        link:"/sub-license-group",
      },
      {
        text:"Activity Group",
        link:"/activity-group",
      },
      {
        text:"Activity",
        link:"/activity",
      },
      {
        text:"Sub Activity",
        link:"/sub-activity",
      },
      {
        text:"Northern Activity",
        link:"/northern-activity",
      },
      {
        text:"Custom Price",
        link:"/pack-price",
      },      
      
    ]
  },
  {
    icon: "activity-round",
    text: "Freelance Activities",
    active: false,
    subMenu: [
      {
        text:"Activity Group",
        link:"/fl-activity-group",
      },      
      {
        text:"Sub Activity",
        link:"/fl-sub-activity",
      },
      {
        text:"Custom Price",
        link:"/fl-custom-price",
      },          
      
    ]
  },
  // {
  //   icon: "activity-round",
  //   text: "Banks",
  //   active: false,
  //   subMenu: [
  //     {
  //       text:"Our Bank",
  //       link:"/bank-partner",
  //     },     
  //     {
  //       text:"Applications",
  //       link:"/bank-application-list",
  //     },          
      
  //   ]
  // },
  {
    icon: "coin",
    text: "Others",
    active: false,
    subMenu: [
      {
        text:"Events",
        link:"/events",
      },
      {
        text:"Process Workflow",
        link:"/workflows",
      },
      {
        text:"Our Bank",
        link:"/bank-partner",
      },
      {
        text:"Video's",
        link:"/video-list",
      },
      {
        text:"Ads",
        link:"/ads",
      },
      {
        text:"FAQs",
        link:"/faqs",
      }
    ]
  },
 
  
  {
    icon:"article",
    text:"Articles",
    link:"/articles",
    dashboard:false,
  },
  
  {
    icon:"article",
    text:"Blogs",
    link:"/blogs",
    dashboard:false,
  },
   
  // {
  //   icon:"card-view",
  //   text:"Test Page",
  //   link:"/test-page",
  //   dashboard:false,
  // },
  {
    icon: "upload",
    text: "Bulk Upload",
    active: false,
    subMenu: [
      // {
      //   text:"Northern Activities",
      //   link:"/upload-north-activities",
      // },
      // {
      //   text:"Freezone Activities",
      //   link:"/upload-activities",
      // },
      {
        text:"Activities upload",
        link:"/upload-freelance-activities",
      },
      {
        text:"Packages upload",
        link:"/upload-products",
      },
      {
        text:"Prices upload",
        link:"/upload-prices",
      },
      
    ]
  }, 
  
 
  {
    icon: "grid-alt",
    text: "Applications",
    active: false,
    subMenu: [ ],
  },
  {
    icon:"video",
    text:"Video Chat",
    link:"/meet",
    dashboard:true,
  },
 
  
  
  {
    icon: "file-docs",
    text: "Pages",
    active: false,
    subMenu: [
      { text: "Commonly Ask", link: "/pages/commonly-ask" },
      { text: "Our Special Deals", link: "/pages/special-deals" },
      { text: "Deals below 7000 AED", link: "/pages/deals-below-7000" },
      { text: "SPC Free Zone Packages", link: "/pages/spc-free-zone" },
      { text: "Best Selling Packages", link: "/pages/best-selling" },
      { text: "Ajman Media City Packages", link: "/pages/ajman-media-city" },
      { text: "UAQ Free Trade Zone Packages", link: "/pages/uaq-free-trade-zone" },
      { text: "Ajman Freezone (AFZ)", link: "/pages/ajman-freezone" },
    ],
  },
  { icon: "search", text: "Page SEO", link: "/page-seo", dashboard: false },
];
export default menu;
